module.exports = __webpack_public_path__ + "img/why-you-need-to-think-api-as-a-product-now.4d49f3a6.jpg";